import axios from 'axios';
//import config from '../config.json';

export default axios.create({
    //baseURL: config.baseURL,
    baseURL : process.env.REACT_APP_NOT_SECRET_BASEURL,
    //timeout: 20000,
    headers: {'Authorization':process.env.REACT_APP_SECRET_AUTHORIZATION}
    
});